import { cn } from "@f2e/ui/lib/utils"

export interface DataItemProps {
  className?: string
  title: string
  valueElement: React.ReactNode
  editable?: boolean
}

const DataItem = ({
  className,
  title,
  valueElement,
  editable = false,
}: DataItemProps) => {
  return (
    <div className={cn("flex flex-col gap-2 py-2 min-h-[40px]", className)}>
      <div className="flex justify-between items-center">
        <div className="font-medium">{title}</div>
        <div
          className={
            !editable ? "cursor-not-allowed text-slate-500" : undefined
          }
        >
          {valueElement}
        </div>
      </div>
    </div>
  )
}

export default DataItem
